import { ManageDiagnosticsCardView } from "./ManageDiagnosticsCardView";

export const ManageDiagnostics = (): JSX.Element => {
  return <ManageDiagnosticsCardView />;
};
